'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildWelcomeMessage = buildWelcomeMessage;
exports.buildQualifiedLeadMessage = buildQualifiedLeadMessage;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _immutable = require('immutable');

var _Message = require('../records/Message');

var _Message2 = _interopRequireDefault(_Message);

var _TargetingRule = require('../records/TargetingRule');

var _TargetingRule2 = _interopRequireDefault(_TargetingRule);

var _TargetAudienceTypes = require('../constants/TargetAudienceTypes');

var _TargetAudienceTypes2 = _interopRequireDefault(_TargetAudienceTypes);

var _MessageTypes = require('../constants/MessageTypes');

var _RuleFactory = require('./RuleFactory');

var _messageType = require('../operators/message/messageType');

var _messageType2 = _interopRequireDefault(_messageType);

var _buildChatHeadingConfigFromJS = require('../chat-heading-config/builders/buildChatHeadingConfigFromJS');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildWelcomeMessage() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var timeStamp = _I18n2.default.moment().format('LLL');

  var defaults = (0, _immutable.Map)({
    name: _I18n2.default.text('conversationsUI.default.name', { timeStamp: timeStamp }),
    createdAt: Number(_I18n2.default.moment.portalTz()),
    initialMessage: _I18n2.default.text('conversationsUI.default.initialMessage'),
    askForEmailMessage: _I18n2.default.text('conversationsUI.default.askForEmailMessage'),
    customAwayMessage: _I18n2.default.text('conversationsUI.default.awayMessage'),
    targetAudienceType: _TargetAudienceTypes2.default.ALL_VISITORS,
    type: (0, _messageType2.default)(data)
  });

  var chatHeadingConfig = (0, _buildChatHeadingConfigFromJS.buildChatHeadingConfigFromJS)(data.chatHeadingConfig);

  return (0, _Message2.default)(defaults.merge((0, _immutable.fromJS)(data))).merge({
    targetingRules: (0, _immutable.List)(data.targetingRules).map(_TargetingRule2.default),
    chatHeadingConfig: chatHeadingConfig
  });
}

function buildQualifiedLeadMessage() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var timeStamp = _I18n2.default.moment().format('LLL');
  var defaults = (0, _immutable.Map)({
    name: _I18n2.default.text('conversationsUI.default.name', { timeStamp: timeStamp }),
    initialMessage: _I18n2.default.text('conversationsUI.default.qualifiedLead.initialMessage'),
    customAwayMessage: _I18n2.default.text('conversationsUI.default.awayMessage'),
    createdAt: Number(_I18n2.default.moment.portalTz()),
    targetAudienceType: _TargetAudienceTypes2.default.ANONYMOUS_VISITORS,
    targetingRules: (0, _immutable.List)(data.targetingRules).map(_TargetingRule2.default),
    type: _MessageTypes.QUALIFIED_LEAD,
    captureVisitorEmailAddress: false
  });

  return (0, _Message2.default)(defaults.merge((0, _immutable.fromJS)(data))).set('sendFromRoutingRules', (0, _get2.default)('sendFromRoutingRules', data) && (0, _RuleFactory.ruleFromJS)((0, _get2.default)('sendFromRoutingRules', data))).set('targetingRules', (0, _immutable.List)(data.targetingRules).map(_TargetingRule2.default));
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/factories/MessageFactory.js
// module id = 621
// module chunks = 2 3